<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-discount"></i>
              用户优惠券
            </h1>
            <p class="page-subtitle">查看客户已领取的优惠券及使用情况，支持按客户和状态筛选</p>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
            <el-form-item label="客户ID">
              <el-input
                v-model="searchCondition.customer_id"
                placeholder="输入客户ID精确查询"
                prefix-icon="el-icon-user"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchCondition.status" placeholder="请选择状态" clearable>
                <el-option label="未使用" value="1"></el-option>
                <el-option label="已锁定" value="2"></el-option>
                <el-option label="已核销" value="3"></el-option>
                <el-option label="已过期/作废" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton" class="search-btn">
                <i class="el-icon-search"></i>
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <ApeTable ref="apeTable" :data="list" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="80" label="序号">
              <template slot-scope="scope">
                <span class="row-number">{{offset+scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column label="券名" min-width="150">
              <template slot-scope="scope">
                <strong class="coupon-name">{{scope.row.name}}</strong>
              </template>
            </el-table-column>
            <el-table-column label="客户" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="customer-id">{{scope.row.customer_id}}</span>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="80" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.type=='1' ? 'primary' : 'success'" size="small">
                  {{ scope.row.type=='1' ? '满减' : '折扣' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="门槛/面额" min-width="130">
              <template slot-scope="scope">
                <span v-if="scope.row.type=='1'">满 {{scope.row.threshold}} 减 {{scope.row.amount}}</span>
                <span v-else>减 {{scope.row.percent}}%</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="110" align="center">
              <template slot-scope="scope">
                <el-tag :type="statusTagType(scope.row.status)" size="small">
                  {{ statusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="发放时间" width="160">
              <template slot-scope="scope">
                {{formatTime(scope.row.issued_at)}}
              </template>
            </el-table-column>
            <el-table-column label="有效期至" width="160">
              <template slot-scope="scope">
                {{formatTime(scope.row.valid_until)}}
              </template>
            </el-table-column>
            <el-table-column label="核销订单" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.used_order_id || '-'}}
              </template>
            </el-table-column>
            <el-table-column v-if="buttonType=='icon'" width="110" label="操作" align="center">
              <template slot-scope="scope">
                <el-popconfirm
                  v-if="scope.row.status=='1' || scope.row.status=='2'"
                  title="作废后该券不可再用，确定作废吗？"
                  @confirm="voidCoupon(scope.row)">
                  <el-tooltip slot="reference" effect="dark" content="作废" placement="top-start">
                    <el-button size="mini" type="danger" icon="el-icon-circle-close" class="action-btn"></el-button>
                  </el-tooltip>
                </el-popconfirm>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import { mapGetters } from 'vuex'

const END_POINT = '/service/ola_app_customer_coupon'

export default {
  components: {
    PageHeaderLayout,
    ApeTable
  },
  data() {
    return {
      searchCondition: {
        customer_id: '',
        status: '',
        current_page: 1,
        page_size: 20,
        query: '',
        params: []
      },
      loadingStaus: true,
      list: [],
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        page_size: 20,
        total: 0
      },
      offset: 0
    }
  },
  computed: {
    ...mapGetters(['buttonType'])
  },
  methods: {
    searchButton() {
      this.initList()
    },
    async switchPaging() {
      this.initList()
    },
    statusText(status) {
      const map = { '1': '未使用', '2': '已锁定', '3': '已核销', '4': '已过期/作废' }
      return map[status] || status
    },
    statusTagType(status) {
      const map = { '1': 'success', '2': 'warning', '3': 'info', '4': 'danger' }
      return map[status] || 'info'
    },
    formatTime(value) {
      if (!value || value === '0000-00-00 00:00:00') return '-'
      return String(value).replace('T', ' ').substring(0, 19)
    },
    async voidCoupon(row) {
      let res = await this.$api.post(END_POINT + '/update', { id: row.id, status: '4' })
      if (this.$apiSuccess(res)) {
        this.$message.success('已作废')
        this.initList()
      }
    },
    async initList() {
      this.loadingStaus = true
      this.searchCondition.params = []
      this.searchCondition.query = ''
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      Object.assign(this.searchCondition, pagingInfo)
      // 组装查询条件（后端仅允许 字段=? 形式，多个用 and 连接）
      let conditions = []
      if (this.searchCondition.customer_id != '') {
        conditions.push('customer_id=?')
        this.searchCondition.params.push(this.searchCondition.customer_id)
      }
      if (this.searchCondition.status != '') {
        conditions.push('status=?')
        this.searchCondition.params.push(this.searchCondition.status)
      }
      if (conditions.length > 0) {
        this.searchCondition.query = conditions.join(' and ')
      }
      let res = await this.$api.post(END_POINT + '/list', this.searchCondition)
      if (this.$apiSuccess(res)) {
        this.list = res.data.list
        this.pagingData.total = res.data.page.total
      }
      this.loadingStaus = false
    }
  },
  mounted() {
    this.initList()
  }
}
</script>

<style lang="stylus" scoped>
  .main-page-content
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px

    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 搜索卡片
  .search-card
    background white
    border-radius 12px
    padding 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .search-header
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .search-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0
    display flex
    align-items center
    gap 8px

  .search-form
    /deep/ .el-form-item
      margin-bottom 16px

    /deep/ .el-form-item__label
      color #374151
      font-weight 500

    /deep/ .el-input__inner
      border-radius 8px
      border 1px solid #d1d5db
      transition all 0.3s ease

      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)

    /deep/ .el-select
      width 180px

  .search-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 12px 24px
    font-weight 500
    transition all 0.3s ease

    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  // 表格卡片
  .table-card
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  // 序号样式
  .row-number
    font-weight 600
    color #667eea
    background #f0f4ff
    padding 4px 8px
    border-radius 4px
    font-size 12px

  .coupon-name
    color #1f2937

  .customer-id
    font-family 'Monaco', 'Consolas', monospace
    font-size 12px
    color #606266

  // 操作按钮
  .action-btn
    margin-left 6px
    border-radius 6px
    padding 6px
    transition all 0.3s ease

    &:hover
      transform translateY(-1px)

  // 表格样式优化
  /deep/ .el-table
    border-radius 8px
    overflow hidden

    th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      border-bottom 2px solid #e5e7eb

    td
      border-bottom 1px solid #f3f4f6

    tr:hover td
      background-color #f8fafc

  /deep/ .el-pagination
    margin-top 24px
    display flex
    justify-content center

  // 响应式设计
  @media (max-width: 768px)
    .main-page-content
      padding 16px

    .page-title-section
      padding 24px 20px

    .page-title
      font-size 24px

    .search-card, .table-card
      padding 16px
</style>
